import type { Page } from '~/types/pages.types'

import type { TAtomIcon } from '~/components/atom/atom-icon/atom-icon.types'

export const DirectionsSlugAsConst = [
    'radioguide',
    'cabin',
    'audioguide',
    'dostupsreda',
    'sinhroperevod',
    'conference-system',
] as const

export const CromiRentDirectionsSlugAsConst = [
    'arenda-radioguides',
    'arenda-audioguides',
    'arenda-video',
    'arenda-zvuka',
    'arenda-konferents-system',
    'arenda-oborudovanie-dlya-sinhronnogo-perevoda',
] as const

export const CromiRentRadioguidesDirectionsSlugAsConst = [
    'radioguide-rent',
] as const

export const SitesDomainAsConst = [
    'cromi.ru',
    'cromi.rent',
    'radioguide.rent',
] as const

export const enum Sites {
    CROMI_RU = 'cromi.ru',
    CROMI_RENT = 'cromi.rent',
    RADIOGUIDE_RENT = 'radioguide.rent',
}
export type TCromiRentRadioguidesDirectionSlug =
    (typeof CromiRentRadioguidesDirectionsSlugAsConst)[number]
export type TCromiRentDirectionSlug =
    (typeof CromiRentDirectionsSlugAsConst)[number]
export type TDirectionSlug = (typeof DirectionsSlugAsConst)[number]
export type TSitesDomain = (typeof SitesDomainAsConst)[number]

export interface ImageSrcInterface {
    webp: string | null
    png: string | null
    alt?: string | null
}

export interface Seo {
    seo_title: string | null
    seo_description: string | null
    og_title: string | null
    og_description: string | null
    og_image: string | null
}

export interface Site {
    created_at: string
    id: number
    name: 'Сromi'
    slug: 'cromi-ru'
    updated_at: string
    url: 'cromi.ru'
}

export interface Image {
    url: string
    mime_type?: string
    width: number | null
    height: number | null
    alt: string | null
    title?: string | null
    webp_url: string | null
    type?: 'image'
}

export interface Video {
    url: string
    mime_type: string
    type: 'video'
}

export interface IDocument {
    size: number | null
    link: string | null
    document_name?: string | null
}

export interface Region {
    object: 'Region'
    id: number | null
    name: string
}

export interface City {
    id: number
    name: string
    region: Include<Region> | null
    sell_region: boolean
    rent_region: boolean
}

export interface ContactSetting {
    whatsApp_phone: string
    whatsApp_message: string
}

export interface MessengerItem {
    icon: TAtomIcon
    link: string
    alt: string
}

export interface AddressCardInfo {
    swiperClass: string
    city: string
    address: string
    phone: string
    tel: string
    email: string
    images: Image[]
}

export interface VideoItem {
    name: string
    title: string
    description: string
    image: string
    image_webp: string
    duration: string
    url: string
}

export interface Category {
    id: number | string
    name: string
    slug: string
    parent_slug?: string | null
    is_published: boolean
    ordering: number
    portfolio_title: string | null
    short_description: string | null
    description: string | null
    page: Page
    parent_category: Include<Category> | null
    seo: Seo
}

export type TGradientType =
    | 'top-left'
    | 'top-right'
    | 'bottom'
    | 'bottom-right'
    | 'left'
